<template>
    <Paper class="rush-order-valid-result" v-loading="loading">
        <div class="vr-valid-title">资质自检结果：<span v-if="grabOrderValid === true" class="vr-success">通过</span><span v-else-if="grabOrderValid === false" class="vr-fail">不通过</span></div>
        <div class="vr-tips">
            <div>自检结果详情：</div>
            <div>
                <span>1. 是否合格物流供应商：</span>
                <span v-if="isLogisticSupplier === true" class="vr-success">是</span>
                <span v-else-if="isLogisticSupplier === false" class="vr-fail">否</span>
            </div>
            <div>
                <span>2. 《道路运输经营许可证》是否上传，且在有效期内：</span>
                <span v-if="existEffectRoadTransport === true" class="vr-success">已上传，在有效期内</span>
                <span v-else-if="existEffectRoadTransport === false" class="vr-fail">未上传，<el-button type="text" @click="handleGo">点击去上传</el-button></span>
            </div>
            <div>
                <span>3. 是否签署运输、配送类合同，且在有效期内：</span>
                <span v-if="existEffectTransportContract === true" class="vr-success">有合同，在有效期内</span>
                <span v-else-if="existEffectTransportContract === false" class="vr-fail">当前未签署有效期合同</span>
            </div>
            <div>
                <span>4. 是否黑名单：</span>
                <span v-if="noneBlackFlag === true" class="vr-success">否</span>
                <span v-else-if="noneBlackFlag === false" class="vr-fail">黑名单</span>
            </div>
            <div>
                <span>5. 是否已有抢单权限，或审批中：</span>
                <span v-if="noneGrabOrder === true && noneMipApproval === true" class="vr-success">否</span>
                <span v-if="noneGrabOrder === false" class="vr-fail">已有抢单权限</span>
                <span v-if="noneMipApproval === false" class="vr-fail"><span v-if="noneGrabOrder === false">，且</span>审批中，无需重复申请</span>
            </div>

            <div>
                <span>6. 是否签署抢单补充协议：</span>
                <span v-if="existsRelationContractFile === true" class="vr-success">是</span>
                <span v-else-if="existsRelationContractFile === false" class="vr-fail">否，{{ noneRelationContractFileInfo }}</span>
            </div>
            <div>
                <span>7. 是否配置审批人：</span>
                <span v-if="existsMipApprovalUser === true" class="vr-success">是</span>
                <span v-else-if="existsMipApprovalUser === false" class="vr-fail">否（如未签署抢单补充协议，此项默认为否）</span>
            </div>

            <!-- <div>
                <span>8. 计费前置校验：</span>
                <span v-if="allMatchMoreRule === true" class="vr-success">通过</span>
                <span v-else-if="allMatchMoreRule === false" class="vr-fail">不通过，{{ noneMatchMoreRuleContract }}</span>
            </div> -->
            <div>
                <span>8. 合同线路维护校验：</span>
                <span v-if="allMatchContractLine === true" class="vr-success">通过</span>
                <span v-else-if="allMatchContractLine === false" class="vr-fail">不通过，{{ noneMatchContractLine }}</span>
            </div>
        </div>
        <div v-if="grabOrderValid === true" class="ro-button-wrap">
            <el-button type="info" :loading="submitLoading" @click="handleSubmit">提交审批</el-button>
            <el-button type="info" @click="handleBack">返回</el-button>
        </div>
        <div v-else class="ro-button-wrap">
            <el-button type="info" @click="handleBack">返回</el-button>
        </div>
    </Paper>
</template>
<script>
import Paper from '@/components/core/paper/Paper';
import { mapState } from 'vuex';
import { validGrabOrder, createFlow } from '../../api/rushOrder/rushOrderAuthApply.js';
import { TABS } from './config.js';
export default {
    components: { Paper },
    data() {
        return {
            loading: false,
            submitLoading: false,
            grabOrderValid: null,
            isLogisticSupplier: null,
            existEffectRoadTransport: null,
            existEffectTransportContract: null,
            noneBlackFlag: null,
            noneGrabOrder: null,
            noneMipApproval: null,
            existsMipApprovalUser: null,
            existsRelationContractFile: null,
            noneRelationContractFileInfo: null,
            // allMatchMoreRule: null,
            // noneMatchMoreRuleContract: null,
            noneMatchContractLine: null,
            allMatchContractLine: null,
            // noneRelationContractFileInfo: 'XXXXX(合同编号)为完成补充协议签署'
        }
    },
    computed: {
        ...mapState(['supplier']),
    },
    methods: {
        handleGo() {
            this.$router.push({
                name: 'basicInfo',
                params: { tabQualifi: true }
            })
        },
        handleSubmit() {
            // this.submitLoading = true
            // setTimeout(() => {
            //     this.submitLoading = false
            //     this.$confirm('提交成功，请等待审批！', '提示', {
            //         confirmButtonText: '确定',
            //         showCancelButton: false,
            //         type: 'success',
            //         center: true
            //     }).then(() => {
            //         this.clear()
            //         this.$emit('valid', TABS[0])
            //     }).catch(() => {
            //         this.clear()
            //         this.$emit('valid', TABS[0])
            //     });
            // }, 1000)

            this.submitLoading = true
            createFlow({ supplierCode: this.supplier.supplierCode }).then(res => {
                if (res && +res.code === 0) {
                    this.$confirm('提交成功，请等待审批！', '提示', {
                        confirmButtonText: '确定',
                        showCancelButton: false,
                        type: 'success',
                        center: true
                    }).then(() => {
                        this.clear()
                        this.$emit('valid', TABS[0])
                    }).catch(() => {
                        this.clear()
                        this.$emit('valid', TABS[0])
                    });
                }
            }).catch(err => {}).finally(() => { this.submitLoading = false })
        },
        validate() {
            // this.loading = true
            // setTimeout(() => {
            //     this.loading = false

            //     this.grabOrderValid = true
            //     this.isLogisticSupplier = true
            //     this.existEffectRoadTransport = true
            //     this.existEffectTransportContract = true
            //     this.noneBlackFlag = true
            //     this.noneGrabOrder = true
            //     this.noneMipApproval = true
            //     this.existsMipApprovalUser = true
            //     this.existsRelationContractFile = true
            //     this.noneRelationContractFileInfo = 'XXXXX(合同编号)为完成补充协议签署'
            // }, 1000)

            this.loading = true
            validGrabOrder({ supplierCode: this.supplier.supplierCode }).then(res => {
                if (res && +res.code === 0) {
                    this.grabOrderValid = res.data.grabOrderValid
                    this.isLogisticSupplier = res.data.isLogisticSupplier
                    this.existEffectRoadTransport = res.data.existEffectRoadTransport
                    this.existEffectTransportContract = res.data.existEffectTransportContract
                    this.noneBlackFlag = res.data.noneBlackFlag
                    this.noneGrabOrder = res.data.noneGrabOrder
                    this.noneMipApproval = res.data.noneMipApproval
                    this.existsMipApprovalUser = res.data.existsMipApprovalUser
                    this.existsRelationContractFile = res.data.existsRelationContractFile
                    this.noneRelationContractFileInfo = res.data.noneRelationContractFileInfo
                    // this.allMatchMoreRule = res.data.allMatchMoreRule
                    this.allMatchContractLine = res.data.allMatchContractLine
                    // this.noneMatchMoreRuleContract = res.data.noneMatchMoreRuleContract
                    this.noneMatchContractLine = res.data.noneMatchContractLine
                }
            }).catch(err => {}).finally(() => { this.loading = false })
        },
        clear() {
            this.grabOrderValid = null
            this.isLogisticSupplier = null
            this.existEffectRoadTransport = null
            this.existEffectTransportContract = null
            this.noneBlackFlag = null
            this.noneGrabOrder = null
            this.noneMipApproval = null
            this.existsMipApprovalUser = null
            this.existsRelationContractFile = null
            this.noneRelationContractFileInfo = null
            // this.allMatchMoreRule = null
            this.allMatchContractLine = null
            // this.noneMatchMoreRuleContract = null
            this.noneMatchContractLine = null
        },
        handleBack() {
            this.clear()
            this.$emit('valid', TABS[0])
        },
    },
    mounted() {
        this.validate()
    }
}
</script>
<style lang="less">
.rush-order-valid-result {
    height: calc(100vh - 60px);

    .vr-valid-title {
        text-align: center;
        font-size: 20px;
        font-weight: bold;
        margin-top: 5%;
        margin-bottom: 30px;
    }
    .vr-tips {
        margin-left: 20%;
        margin-bottom: 50px;
        line-height: 1.8em;
    }
    .vr-success {
        color: #85c029;
    }
    .vr-fail {
        color: #d9001b;
    }
    .el-button--text {
        font-size: initial;
    }
    .ro-button-wrap {
        text-align: center;

        .el-button {
            font-size: 20px;
            background-color: #409eff;
            border-color: #409eff;
        }
        .el-button--info:hover, .el-button--info:focus {
            background: #66b1ff;
            border-color: #66b1ff;
        }
        .el-button--info.is-active, .el-button--info:active {
            background: #3a8ee6;
            border-color: #3a8ee6;
            color: #fff;
        }
    }
}
</style>
